import { AppSettings } from "./AppSettings";

const ColourConverter = (colour: string | undefined) => {

    if (!colour) {
        return undefined
    }

    switch (colour) {
        case 'RedDark':
            return AppSettings.palette.RedDark;
        case 'RedLight':
            return AppSettings.palette.RedLight;
        case 'GreenDark':
            return AppSettings.palette.GreenDark;
        case 'GreenLight':
            return AppSettings.palette.GreenLight;
        case 'OrangeDark':
            return AppSettings.palette.OrangeDark;
        case 'OrangeLight':
            return AppSettings.palette.OrangeLight;
        default:
            return colour;
    }
}

export default ColourConverter;
